export const Divider = () => {
  return (
    <div className={'border-t border-outline-secondary'}/>
  )
}
